import PropTypes from 'prop-types';
import { forwardRef, useEffect, useState } from 'react';
import { getFiscalYearList } from 'Util/dateUtil';
import styles from './FiscalYearSelect.module.css';
import BOSFilterSelect from './index';

const FiscalYearSelect = forwardRef(
  (
    {
      onSelectFiscalYear = () => {},
      defaultSelectedYear,
      labelText,
      placeholder = 'Year...',
      numberOfYearsToShow = 10,
      simple = false,
      fill,
      autoMarginLeft = false,
      additionalListItems = [],
      matchWidth = false,
    },
    ref,
  ) => {
    const [yearList, setYearList] = useState([]);

    useEffect(() => {
      setYearList([
        ...additionalListItems.map((item) => {
          return { year: item };
        }),
        ...getFiscalYearList(numberOfYearsToShow),
      ]);
    }, []);

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'end',
          minWidth: 72,
          ...(!fill && { width: simple ? 80 : 102 }),
          ...(fill && matchWidth && { flexGrow: 1, maxWidth: 200 }),
        }}
        className={
          simple
            ? styles.fiscal_input_simple
            : autoMarginLeft
            ? styles.fiscal_input_auto_margin
            : styles.fiscal_input
        }>
        <BOSFilterSelect
          ref={ref}
          listData={yearList}
          defaultSelectedId={defaultSelectedYear}
          onItemSelect={onSelectFiscalYear}
          placeholder={placeholder}
          idField={'year'}
          labelField={'year'}
          labelText={labelText}
          searchField={'year'}
          floatSelected={false}
          hideClearButton
          matchTargetWidth={
            matchWidth ||
            (!additionalListItems?.length && numberOfYearsToShow < 11)
          }
          simple={simple}
          fill={fill}
          width={simple ? 80 : matchWidth ? 200 : 102}
        />
      </div>
    );
  },
);

FiscalYearSelect.displayName = 'FiscalYearSelect';

FiscalYearSelect.propTypes = {
  labelText: PropTypes.string,
  onSelectFiscalYear: PropTypes.func,
  defaultSelectedYear: PropTypes.string,
  placeholder: PropTypes.string,
  numberOfYearsToShow: PropTypes.number,
  simple: PropTypes.bool,
  fill: PropTypes.bool,
  autoMarginLeft: PropTypes.bool,
  additionalListItems: PropTypes.array,
  matchWidth: PropTypes.bool,
};

export default FiscalYearSelect;
